import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {provideTransloco} from '@jsverse/transloco';
import {provideTranslocoLocale} from '@jsverse/transloco-locale';
import {TranslocoHttpLoader} from '../transloco-loader';

import { routes } from './app.routes';
import {DEFAULT_LOCALE, LOCALES} from './core/locale/locales';
import { provideSentry } from './core/provider/sentry.provider';
import { networkThrottleInterceptor } from './core/interceptor/network-throttle.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([networkThrottleInterceptor])),
    provideSentry(),
    provideTransloco({
      config: {
        availableLangs: LOCALES.map(l => l.code),
        defaultLang: DEFAULT_LOCALE,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoLocale({
      langToLocaleMapping: {
        de: 'de-DE',
        en: 'en-US',
        es: 'es-ES',
        fr: 'fr-FR',
        it: 'it-IT',
        nl: 'nl-NL',
        pt: 'pt-PT',
      },
    }),
  ],
};
